import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Anchor, Flex, Image, Text } from '@mantine/core';

export const LogoTitleBarComponent = () => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);

    const style = {
        transform: show ? 'rotate(360deg)' : '',
        transition: 'transform 150ms ease'
    };

    const handleHeaderClick = () => {
        void navigate('/');
        setShow(!show);
    };

    return (
        <Flex direction={'row'} p={'0'}>
            <Anchor
                onClick={() => handleHeaderClick()}
                draggable={false}
                style={{ textDecoration: 'inherit', color: 'inherit' }}
            >
                <Flex direction={'row'} gap={'sm'} align={'center'}>
                    <Image
                        src={'/applogo.png'}
                        alt={'App Logo'}
                        w={30}
                        mx={0}
                        radius='sm'
                        style={style}
                    />
                    <Text
                        fw={800}
                        size='sm'
                        style={{
                            letterSpacing: '0.14em',
                            textTransform: 'uppercase'
                        }}
                    >
                        Firedocs
                    </Text>
                </Flex>
            </Anchor>
        </Flex>
    );
};
